/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MatchSearchResultDTO { 
    match_id: number;
    match_date: string;
    video_title: string;
    season_id: number;
    competition_name: string;
    category_name: string;
    home_team_id: string;
    home_team_name: string;
    home_score: number;
    away_team_id: string;
    away_team_name: string;
    away_score: number;
    match_day?: number | null;
}

